import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

export const UnionInfoCard = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/union").then((r) => setForm(r.data));
  }, []);

  const save = async () => {
    if (!form.name.trim()) return toast.error("Birlik adı zorunludur");
    setSaving(true);
    try {
      const r = await api.put("/settings/union", form);
      setForm(r.data);
      toast.success("Birlik bilgileri kaydedildi");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.toString?.() || "Kaydedilemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="p-6 border border-slate-200 shadow-sm max-w-2xl mb-6" data-testid="union-info-card">
      <h3 className="font-display font-semibold text-slate-900">Birlik Bilgileri</h3>
      <p className="text-sm text-slate-500 mt-1">
        Birlik adı raporların başlığında; adres ve telefon başlığın altında ve her sayfanın alt bilgisinde görünür.
      </p>
      {!form ? (
        <div className="text-sm text-slate-500 mt-4">Yükleniyor...</div>
      ) : (
        <div className="space-y-4 mt-5">
          <div>
            <Label>Birlik Adı *</Label>
            <Input value={form.name} maxLength={120} onChange={(e) => setForm({ ...form, name: e.target.value })}
                   data-testid="union-name-input" />
          </div>
          <div>
            <Label>Adres</Label>
            <Textarea rows={2} value={form.address} maxLength={300}
                      onChange={(e) => setForm({ ...form, address: e.target.value })} data-testid="union-address-input" />
          </div>
          <div>
            <Label>Telefon</Label>
            <Input value={form.phone} maxLength={40} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                   data-testid="union-phone-input" />
          </div>
          <div className="pt-2 border-t border-slate-100">
            <div className="text-sm font-medium text-slate-800">PDF Rapor İmza Alanı</div>
            <p className="text-xs text-slate-500 mt-0.5">
              Raporun sonunda "Hazırlayan" olarak raporu indiren kullanıcının adı, "Onaylayan" olarak aşağıdaki kişi yazılır.
              Boş bırakılırsa elle doldurulacak boş satır çıkar.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label>Onaylayan Adı Soyadı</Label>
              <Input value={form.approver_name || ""} maxLength={120}
                     onChange={(e) => setForm({ ...form, approver_name: e.target.value })} data-testid="union-approver-name-input" />
            </div>
            <div>
              <Label>Onaylayan Unvanı</Label>
              <Input value={form.approver_title || ""} maxLength={120} placeholder="Ör. Birlik Başkanı"
                     onChange={(e) => setForm({ ...form, approver_title: e.target.value })} data-testid="union-approver-title-input" />
            </div>
          </div>
          <Button onClick={save} disabled={saving} className="bg-emerald-700 hover:bg-emerald-800" data-testid="union-save-button">
            {saving ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Save className="h-4 w-4 mr-1.5" />}
            Kaydet
          </Button>
        </div>
      )}
    </Card>
  );
};
